import React from 'react'
import './Header.css';

const Header = () => {
    return (
        <div className= "header-asistencias-prefectos">
            <div className= "titulo-asistencias-prefectos">
                <h2>
                    Información de Alumnos
                </h2>
                <p>
                    Busca y consula la información de los Alumnos
                </p>
            </div>
        </div>
    );
};

export default Header;